import axios from 'axios'
import { Toast, Dialog } from 'vant'
import store from '../store'
import { isFangCheBaoApp, isIOS, isAndroid, sendLog, mixinGoBack } from '@/utils/index'
import { isMiniProgramNew } from '@/globalFun'
import { v4 as uuidv4 } from 'uuid'
import { setStorage, getStorage } from '@/utils/storage'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // 基础api
  timeout: 30000, // 请求超时时间
  withCredentials: true,
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    // loading 处理
    if (config.showLoading) {
      store.commit('showPageLoading')
    }
    // App版本号
    config.headers.ha_app_version = hcApp.getAppVersion() || '1.0.6'

    // 时间戳s
    config.headers.ha_timestamp = new Date().getTime()

    let channel = 3000805 // 3000805 普通H5渠道
    if (hcApp.isHCIOSApp()) {
      if (navigator.userAgent.includes('inner')) {
        channel = 3000809
      } else {
        channel = 3000801
      }
    } else if (hcApp.isHCAndroidApp()) {
      if (navigator.userAgent.includes('inner')) {
        channel = 3000810
      } else {
        channel = 3000802
      }
    } else if (isMiniProgramNew()) {
      channel = 3000803
    } else if (isFangCheBaoApp()) {
      if (isIOS()) {
        channel = 3000811
      } else {
        channel = 3000812
      }
    }
    config.headers.ha_channel_code = channel // 渠道号
    config.headers.ha_language = 'zh' // 语言

    if (store.state.userInfo) {
      const userInfo = store.state.userInfo
      // 登陆token
      userInfo.acpToken && (config.headers.ha_acp_token = userInfo.acpToken)
      userInfo.deviceBrand && (config.headers.ha_device_brand = encodeURIComponent(userInfo.deviceBrand)) // 设备品牌
      userInfo.deviceModel && (config.headers.ha_device_model = encodeURIComponent(userInfo.deviceModel)) // 设备品牌
      userInfo.deviceOs && (config.headers.ha_os = encodeURIComponent(userInfo.deviceOs)) // 设备品牌
      userInfo.deviceOsVersion && (config.headers.ha_os_version = encodeURIComponent(userInfo.deviceOsVersion)) // 设备品牌
      userInfo.deviceId && (config.headers.ha_device_id = encodeURIComponent(userInfo.deviceId)) // 设备品牌
    }
    if (!hcApp.isHCApp()) {
      // 如果不是恒驰App，则生成uuid当做设备id
      if (!localStorage.getItem('mockDeviceId')) {
        localStorage.setItem('mockDeviceId', uuidv4())
      }
      config.headers.ha_device_id = localStorage.getItem('mockDeviceId')
    }

    // 阿里云风控参数
    // config.headers.ha_atk = encodeURIComponent(window.aliUabModule?.getUA())
    // config.headers.ha_wut = encodeURIComponent(window.aliWebUmidToken)

    // 网易易盾风控参数
    if (config.appendWangYiToken) {
      return new Promise((resolve) => {
        wangYiYD.getToken(
          process.env.VUE_APP_WANGYI_BUSINESSCODE,
          (token) => {
            config.headers.ha_ydt = encodeURIComponent(token)
            resolve(config)
          },
          (error) => {
            console.error('未获取到网易风控参数')
            sendLog({
              type: 'wangyiError',
              error: error,
              token: store.state.userInfo?.acpToken,
            })
          }
        )
      })
    } else {
      return config
    }
  },
  (error) => {
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  async (response) => {
    // 隐藏loading
    if (response.config?.showLoading) {
      store.commit('hidePageLoading')
    }
    const data = response.data
    if (data.respCode === '0') {
      // 接口缓存，默认缓存5分钟
      if (response.config.cacheTime) {
        const key = genCacheKey(response.config.url, JSON.parse(response.config.data))
        setStorage(key, data.result, response.config.cacheTime || 60 * 5)
      }

      return data.result
    } else if (data.subCode?.includes('611')) {
      // 发短信前的图形验证码相关接口的错误，需要原样返回
      return data
    } else {
      // 未登录拦截
      store.commit('hidePageLoading')

      if (data?.respCode === '405' || data?.respCode === '5010013') {
        // ios 1.1.0版本以下拉起登录态有问题
        if (hcApp.isHCIOSApp() && hcApp.isLessThan('1.1.0')) {
          Dialog.alert({
            title: '提示',
            message: '抱歉，登录态已失效，请登录后重试',
          }).then(() => {
            mixinGoBack()
          })
        } else if (hcApp.isHCApp()) {
          const oldToken = store.state.userInfo?.acpToken
          const userInfo = await hcApp.postMessage({ methodName: 'login' })
          if (oldToken !== userInfo?.acpToken && userInfo?.acpToken) {
            await store.dispatch('getUserInfo')
            return await request({
              method: response.config.method,
              url: response.config.url,
              data: JSON.parse(response.config.data),
            })
          } else {
            setTimeout(() => {
              mixinGoBack()
            }, 500)
          }
        } else if (isMiniProgramNew()) {
          console.log('小程序未登录')
          if (!window.jumpMiniLoginFlag) {
            wx.miniProgram.navigateTo({
              url: `/pages/login/login?callBackType=h5&callBackUrl=${encodeURIComponent(
                location.href
              )}&replaceCurrentPage=1`,
            })
            window.jumpMiniLoginFlag = true
            setTimeout(() => {
              window.jumpMiniLoginFlag = false
            }, 500)
          }
        }
        return Promise.reject(data)
      } else {
        !response.config.noToast &&
          Toast(data?.subCodeMsg?.substring(0, 300) || data.msg?.substring(0, 300) || '未知异常')
        return Promise.reject(data)
      }
    }
  },
  async (error) => {
    console.error('接口请求失败', error)
    // 上报日志服务器
    sendLog({
      type: 'api fail',
      apiUrl: error.request?._url,
      data: error.config?.data,
      message: error.message,
      stack: error.stack,
    })
    // 隐藏loading
    if (error.config?.showLoading) {
      store.commit('hidePageLoading')
    }

    // 接口重试
    if (
      error.config?.retryCount &&
      (!error.config?.retryCounter || error.config.retryCounter < error.config.retryCount)
    ) {
      if (error.config.retryCounter) {
        error.config.retryCounter += 1
      } else {
        error.config.retryCounter = 1
      }
      return request(error.config)
    } else {
      console.error('请求报错:', error)
      Toast('网络异常，请稍后重试！')
      return Promise.reject(error)
    }
  }
)

// 生产缓存的key，key使用url和data拼接，如果用户是登录态，则拼接token前6位
function genCacheKey(url, data = {}) {
  let key = url
  for (const itemKey in data) {
    key = `${key}&${itemKey}=${data[itemKey]}`
  }
  const acpToken = store.state.userInfo.acpToken
  return acpToken ? key + '_' + acpToken.substring(0, 6) : key
}

export default function request(options) {
  // 接口缓存处理,如果已登录，则key以acpToken的前6位开头
  if (options.cacheTime) {
    const key = genCacheKey(options.url, options.data)
    const cacheData = getStorage(key)
    if (cacheData) {
      return cacheData
    }
  }
  return service(options)
}
